/**
 * @generated SignedSource<<862aa99de7a17b6d17c057e53a00510f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JQLBuilderWithAI$data = {
  readonly shouldShowAtlassianIntelligence: boolean | null | undefined;
  readonly userPreferences: {
    readonly " $fragmentSpreads": FragmentRefs<"NaturalLanguageToJQLWrapper" | "SpotlightTourContainer" | "main_jqlBuilder_JQLBuilder">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"NaturalLanguageToggle">;
  readonly " $fragmentType": "JQLBuilderWithAI";
};
export type JQLBuilderWithAI$key = {
  readonly " $data"?: JQLBuilderWithAI$data;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderWithAI">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "atlassianIntelligenceProductFeature"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "JQLBuilderWithAI",
  "selections": [
    {
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "feature",
              "variableName": "atlassianIntelligenceProductFeature"
            }
          ],
          "kind": "ObjectValue",
          "name": "atlassianIntelligenceProductFeatureInput"
        },
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "shouldShowAtlassianIntelligence"
    },
    {
      "kind": "FragmentSpread",
      "name": "NaturalLanguageToggle"
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "JiraUserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SpotlightTourContainer"
        },
        {
          "kind": "FragmentSpread",
          "name": "NaturalLanguageToJQLWrapper"
        },
        {
          "kind": "FragmentSpread",
          "name": "main_jqlBuilder_JQLBuilder"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "00e6c09233a8c34ff892e488f46b2fee";

export default node;
